"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MessageCircleQuestionMark } from "lucide-react";
const faqs = [{
  question: "How much does junk removal in Nepean cost?",
  answer: "Our pricing is based on the volume your items occupy in our truck. We provide free, no-obligation on-site estimates to ensure you get the most accurate and fair price for your specific needs."
}, {
  question: "Do you offer same-day service in my neighborhood?",
  answer: "Yes, we frequently offer same-day or next-day pickups throughout Nepean, including Barrhaven, Bells Corners, and Centrepointe. Contact us early in the day to secure your preferred time slot."
}, {
  question: "What types of items can you remove?",
  answer: "We handle almost anything from old furniture and appliances to construction debris and yard waste. Please note we cannot accept hazardous materials like chemicals, oils, or paints."
}, {
  question: "How do you handle recyclable or reusable items?",
  answer: "We are committed to sustainability. We sort through every load to ensure that recyclables are processed correctly and usable items are donated to local Nepean charities whenever possible."
}, {
  question: "Which Nepean neighborhoods do you cover?",
  answer: "We serve the entire Nepean area, including Tanglewood, Craig Henry, West Hunt Club, and Manordale. If you are within the K2 or K2H postal codes, we have teams nearby."
}];
export default function FaqNepean() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="258839" id="faq-nepean" className="bg-background text-foreground py-20 lg:py-32">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-xl mb-6">
            <MessageCircleQuestionMark className="w-8 h-8 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            Nepean Junk Removal FAQ
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-default">
            Have questions about clearing out your space? Find quick answers about our local services, pricing, and eco-friendly disposal methods.
          </p>
        </div>

        <div className="bg-card rounded-lg shadow-lg border border-border p-6 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold font-default text-primary hover:text-secondary py-5 transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed font-default pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-6 font-default">
            Don't see your question here? Our local team is ready to help.
          </p>
          <Button asChild variant="outline" size="lg" className="rounded-lg border-primary text-primary hover:bg-primary hover:text-primary-foreground">
            <Link to="#">Contact Our Team</Link>
          </Button>
        </div>
      </div>
    </section>;
}